/**
 * Zip Range A & B buckets by ordinal index. Period-over-period compares positions, not
 * calendar dates (the ranges usually differ in length, e.g. this-month vs last-month),
 * so bucket i of A overlays bucket i of B. The tooltip shows both real dates so the
 * ordinal alignment is never misleading.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { AlignedRow, TimeSeriesBucket } from './types';

export function alignBuckets(
  a?: TimeSeriesBucket[],
  b?: TimeSeriesBucket[],
): AlignedRow[] {
  const len = Math.max(a?.length ?? 0, b?.length ?? 0);
  const out: AlignedRow[] = [];
  for (let i = 0; i < len; i += 1) {
    out.push({ index: i, bucketA: a?.[i], bucketB: b?.[i] });
  }
  return out;
}
